(function () {

  const header = document.querySelector(".shopify-section-header");

  const isIndex = document.body.classList.contains("template-index");



  const solidHeader = (on) => {

    document.body.classList.toggle("dotthz-header-solid", on);

    if (header) header.classList.toggle("dotthz-header-solid", on);

  };



  const onScroll = () => {

    if (!isIndex) {

      solidHeader(true);

      return;

    }

    solidHeader(window.scrollY > 16);

  };



  onScroll();

  window.addEventListener("scroll", onScroll, { passive: true });



  const desktopHoverSwap = () => {

    if (!window.matchMedia("(hover: hover) and (min-width: 990px)").matches) return;

    document.querySelectorAll(".card-wrapper .product-card-js").forEach((el) => {

      const card = el.closest(".card-wrapper");

      const swiper = el.swiper;

      if (!card || !swiper || card.dataset.dotthzHover === "1") return;

      card.dataset.dotthzHover = "1";

      card.addEventListener("mouseenter", () => {

        if (swiper.slides.length > 1) swiper.slideTo(1);

      });

      card.addEventListener("mouseleave", () => {

        swiper.slideTo(0);

      });

    });

  };



  const productTabs = () => {

    document.querySelectorAll("[data-dotthz-tabs]").forEach((root) => {

      const tabs = root.querySelectorAll(".dotthz-tabs__tab");

      const panels = root.querySelectorAll(".dotthz-tabs__panel");

      tabs.forEach((tab) => {

        tab.addEventListener("click", () => {

          const id = tab.getAttribute("data-tab");

          tabs.forEach((t) => {

            t.classList.toggle("is-active", t === tab);

            t.setAttribute("aria-selected", t === tab ? "true" : "false");

          });

          panels.forEach((panel) => {

            const match = panel.getAttribute("data-panel") === id;

            panel.classList.toggle("is-active", match);

            panel.hidden = !match;

          });

        });

      });

    });

  };



  const freeShipping = () => {
    // PDP: hide free-shipping line (kept on announcement bar / elsewhere)
    if (document.body.classList.contains("template-product")) {
      document.querySelectorAll(".dotthz-free-shipping").forEach((el) => {
        el.remove();
      });
      return;
    }

    document.querySelectorAll(".dotthz-free-shipping").forEach((el) => {
      const country = (el.getAttribute("data-country") || "").toUpperCase();
      if (country === "US") {
        el.textContent = "Free shipping on orders over $300";
      } else {
        el.textContent = "Free shipping on orders over €300";
      }
    });
  };

  /* Announcement bar messages come from Theme Editor blocks — do not override */



  const shopFeedArrows = () => {

    document.querySelectorAll('[class*="ai-styled-gallery-container-"]').forEach((container) => {

      if (container.parentElement.querySelector(".dotthz-feed-nav")) return;

      const grid = container.querySelector('[class*="ai-styled-gallery-grid-"]');

      if (!grid) return;



      const wrap = document.createElement("div");

      wrap.className = "dotthz-feed-nav";

      wrap.innerHTML =

        '<button type="button" class="dotthz-feed-nav__btn" data-dir="-1" aria-label="Previous">‹</button>' +

        '<button type="button" class="dotthz-feed-nav__btn" data-dir="1" aria-label="Next">›</button>';

      container.style.position = "relative";

      container.appendChild(wrap);



      wrap.querySelectorAll("button").forEach((btn) => {

        btn.addEventListener("click", () => {

          const dir = Number(btn.getAttribute("data-dir"));

          grid.scrollBy({ left: dir * Math.max(grid.clientWidth * 0.6, 280), behavior: "smooth" });

        });

      });

    });

  };



  const shopFeedAutoscroll = () => {
    document.querySelectorAll('[class*="ai-styled-gallery-grid-"]').forEach((grid) => {
      if (grid.dataset.dotthzAuto === "1") return;

      const items = Array.from(grid.children);
      if (items.length < 2) return;

      grid.dataset.dotthzAuto = "1";

      // Duplicate slides so the row can loop continuously
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.classList.add("dotthz-feed-clone");
        grid.appendChild(clone);
      });

      let paused = false;
      const pause = () => {
        paused = true;
      };
      const resume = () => {
        paused = false;
      };

      grid.addEventListener("mouseenter", pause);
      grid.addEventListener("mouseleave", resume);
      grid.addEventListener("touchstart", pause, { passive: true });
      grid.addEventListener("touchend", () => setTimeout(resume, 2000), { passive: true });

      const tick = () => {
        if (paused || document.hidden) return;
        const half = grid.scrollWidth / 2;
        if (half <= 8) return;
        const step = Math.max(Math.round(grid.clientWidth * 0.55), 200);
        const next = grid.scrollLeft + step;
        if (next >= half - 2) {
          grid.scrollTo({ left: next - half, behavior: "auto" });
          requestAnimationFrame(() => {
            grid.scrollBy({ left: step, behavior: "smooth" });
          });
        } else {
          grid.scrollBy({ left: step, behavior: "smooth" });
        }
      };

      // Start after layout settles so scrollWidth is correct
      setTimeout(() => {
        tick();
        setInterval(tick, 3500);
      }, 800);
    });
  };



  const heroBannerClick = () => {

    document.querySelectorAll(".image-banner .banner").forEach((banner) => {

      const link = banner.querySelector(".image-banner__full-link");

      if (!link || banner.dataset.dotthzHero === "1") return;

      banner.dataset.dotthzHero = "1";

      banner.addEventListener("click", (event) => {

        if (event.target.closest("a:not(.image-banner__full-link)")) return;

        window.location.assign(link.href);

      });

    });

  };



  const hideJewellery = () => {
    // Jewellery collection is live — do not hide nav links.
    return;
  };



  const mobileCardSwipe = () => {

    if (window.matchMedia("(hover: hover) and (min-width: 990px)").matches) return;

    document.querySelectorAll(".card-wrapper .product-card-js").forEach((el) => {

      const swiper = el.swiper;

      if (!swiper || el.dataset.dotthzMobileSwipe === "1") return;

      el.dataset.dotthzMobileSwipe = "1";

      swiper.slideTo(0);

      const pagination = el.parentElement?.querySelector(".swiper-pagination");

      if (pagination) pagination.style.opacity = "1";

    });

  };



  const collectionScrollTitles = () => {
    // Disabled: large black bag-name overlays on scroll were removed per brand feedback.
    return;
  };



  const pdpStickyBar = () => {
    const bar = document.getElementById("dotthz-pdp-sticky");
    if (!bar || !document.body.classList.contains("template-product")) return;

    const footer = document.querySelector("footer") || document.querySelector(".footer");
    const atcBtn = bar.querySelector("[data-dotthz-sticky-atc]");
    const mainAtc =
      document.querySelector(".product-form .product-form__submit") ||
      document.querySelector("button[name='add']") ||
      document.querySelector(".product-form__submit");
    const priceEl = bar.querySelector(".dotthz-pdp-sticky__price");
    const limitedStock = document.querySelector("[data-dotthz-limited-stock]");

    const getNotifyOpen = () =>
      document.querySelector(".notify-button[disabled] .notify-open-button") ||
      document.querySelector(".notify-button .notify-open-button");

    const syncStock = () => {
      if (!atcBtn || !mainAtc) return;
      const soldOut = mainAtc.hasAttribute("disabled");
      const notifyOpen = getNotifyOpen();
      const notifyVisible =
        !!document.querySelector(".notify-button[disabled]") ||
        (notifyOpen && window.getComputedStyle(notifyOpen.closest(".notify-button")).display !== "none");

      bar.classList.toggle("is-sold-out", soldOut);
      bar.dataset.available = soldOut ? "false" : "true";

      if (soldOut) {
        atcBtn.textContent = notifyVisible || notifyOpen ? "Notify Me" : "Sold Out";
        atcBtn.setAttribute("data-dotthz-sticky-notify", "");
        if (limitedStock) limitedStock.hidden = true;
      } else {
        atcBtn.textContent = "Add to Bag";
        atcBtn.removeAttribute("data-dotthz-sticky-notify");
        if (limitedStock) limitedStock.hidden = false;
      }
    };

    if (atcBtn && mainAtc) {
      atcBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const notifyOpen = getNotifyOpen();
        if (mainAtc.disabled || atcBtn.hasAttribute("data-dotthz-sticky-notify")) {
          if (notifyOpen) notifyOpen.click();
          return;
        }
        mainAtc.click();
      });
    }

    const syncPrice = () => {
      if (!priceEl) return;
      const livePrice =
        document.querySelector(".price--product .price-item--sale, .price--product .price-item--regular, .product .price .price-item") ||
        document.querySelector(".product .price-item--regular, .product .price-item--sale");
      if (livePrice) priceEl.textContent = livePrice.textContent.trim();
    };

    const setVisible = (visible) => {
      syncPrice();
      syncStock();
      bar.hidden = false;
      bar.removeAttribute("hidden");
      bar.setAttribute("aria-hidden", visible ? "false" : "true");
      bar.classList.toggle("is-visible", visible);
      document.body.classList.toggle("dotthz-sticky-atc-on", visible);
    };

    const update = () => {
      // Keep sticky CTA accessible for almost the full page scroll.
      const footerNear = footer
        ? footer.getBoundingClientRect().top < window.innerHeight * 0.88
        : false;
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      const nearTop = isMobile ? window.scrollY < 12 : window.scrollY < 40;
      // On mobile, keep sticky ATC visible sooner for conversion.
      setVisible(isMobile ? !footerNear : (!nearTop && !footerNear));
    };

    syncStock();
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    document.addEventListener("change", () => {
      syncPrice();
      // Variant radios update ATC disabled state after theme JS — sync shortly after.
      setTimeout(syncStock, 50);
      setTimeout(syncStock, 250);
    });
    setTimeout(update, 300);
    setTimeout(update, 1000);
  };



  const hideReadyToWear = () => {

    document.querySelectorAll("a, .list-menu__item, .footer-block__details-content a").forEach((el) => {

      const t = (el.textContent || "").trim().toLowerCase();

      if (t.includes("ready to wear") || t === "rtw 25" || t.includes("ready to wear 25")) {

        const item = el.closest("li") || el;

        item.style.display = "none";

      }

    });

  };



  const colorLabelSync = () => {

    const labels = document.querySelectorAll("[data-dotthz-selected-color], .product-options-name");

    if (!labels.length) return;



    document.addEventListener("change", (event) => {

      const input = event.target;

      if (!(input instanceof HTMLInputElement)) return;

      if (!input.closest(".product-form__controls, variant-selects, variant-radios")) return;



      const fieldset = input.closest("fieldset") || input.closest(".product-form__controls");

      const nameEl = fieldset?.querySelector(".product-options-name, [data-dotthz-selected-color]");

      const value =

        input.getAttribute("data-option-value") ||

        input.getAttribute("value") ||

        input.nextElementSibling?.textContent ||

        "";

      if (nameEl && value) nameEl.textContent = value.trim();



      document.querySelectorAll("[data-dotthz-color-swatches] [data-dotthz-selected-color]").forEach((el) => {

        if (value) el.textContent = value.trim();

      });

    });

  };



  const ready = () => {

    desktopHoverSwap();

    productTabs();

    freeShipping();

    shopFeedArrows();

    shopFeedAutoscroll();

    hideJewellery();

    heroBannerClick();

    mobileCardSwipe();

    collectionScrollTitles();

    pdpStickyBar();

    colorLabelSync();

    hideReadyToWear();

  };



  if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", ready);

  } else {

    ready();

  }



  window.addEventListener("load", () => {

    desktopHoverSwap();

    shopFeedArrows();

    shopFeedAutoscroll();

    mobileCardSwipe();

    collectionScrollTitles();

    pdpStickyBar();

    hideReadyToWear();

  });

  setTimeout(desktopHoverSwap, 600);

  setTimeout(desktopHoverSwap, 1600);

  setTimeout(mobileCardSwipe, 600);

  setTimeout(mobileCardSwipe, 1600);



  document.addEventListener("shopify:section:load", ready);

  /* Theme editor: only force Shop mega open while Header is selected */
  (function editorMegaGate() {
    const isHeaderContext = (sectionId) => {
      if (!sectionId) return false;
      const id = String(sectionId).toLowerCase();
      return id.indexOf("header") !== -1;
    };

    const setShow = (on) => {
      document.documentElement.classList.toggle("dotthz-editor-show-mega", !!on);
    };

    document.addEventListener("shopify:section:select", (event) => {
      setShow(isHeaderContext(event.detail && event.detail.sectionId));
    });

    document.addEventListener("shopify:section:deselect", () => {
      setShow(false);
    });

    document.addEventListener("shopify:block:select", (event) => {
      setShow(isHeaderContext(event.detail && event.detail.sectionId));
    });

    document.addEventListener("shopify:block:deselect", () => {
      setShow(false);
    });
  })();

})();

